import React from 'react'
import PropTypes from 'prop-types'
import { get, toPairs, includes } from 'lodash'
import { Col, Row, Icon, Collapse, Rate, Tooltip } from 'antd'
import { GoogleMapsView } from '../../third-party/GoogleMaps'
import { Number, Text } from '../../common';
import LastPurchasesTable from './LastPurchasesTable'

const styles = {
  tag: {
    padding: '0px 10px',
    textAlign: 'center',
    borderRadius: 15,
    backgroundColor: '#333333',
    color: 'white'
  },
  tagText: { fontSize: '0.8rem' }
}

const Panel = Collapse.Panel

class CustomerResumeCard extends React.Component {
  _resolveDataProp = (propName) => {
    return get(this.props.data, propName)
  }

  _onClickEditBtn = () => {
    console.log('should open detail bar')
    this.props.toggleChildDrawer()
  }

  _headerRightContent = (
    <Row type='flex' justify='space-between' >
      <Col>
        <div style={styles.tag}>
          <Text style={styles.tagText} className='text-overflow' text='customer.tags.black_list' />
        </div>
      </Col>
      <Col>
        <div style={styles.tag}>
          <Text style={styles.tagText} className='text-overflow' text='customer.tags.collaborator' />
        </div>
      </Col>
      <Col>
        <Tooltip title='Editar'>
          <Icon type='edit' onClick={this._onClickEditBtn} />
        </Tooltip>
      </Col>
    </Row>
  )

  _headerLeftContent = () => (
    (
      <div>
        <h4 className='no-margin'>
          <strong>{this._resolveDataProp('first_name')}</strong>
        </h4>
        <span>{this._resolveDataProp('rut')}</span>
      </div>
    )
  )
  _renderHeader = () => (
    <Row type='flex' style={{ marginBottom: 10 }}>
      <Col span={16}>
        {this._headerLeftContent()}
      </Col>
      <Col span={8}>
        {this._headerRightContent}
      </Col>
    </Row>
  )

  _renderPersonalInfo = (data) => {
    const validKeys = ['createdAt', 'rut', 'email', 'password']
    const fields = toPairs(data).filter(([key]) => includes(validKeys, key))
    return fields.map(([label, value], key) => (
      <Row type='flex' key={key}>
        <Col span={8}>
          <strong>
            {label}
          </strong>
        </Col>
        <Col span={16}>
          <span>
            {value}
          </span>
        </Col>
      </Row>
    ))
  }

  _renderOrdersResume = () => {
    return (
      <Row type='flex'>
        <Col span={8} className='box-border-left'>
          <div className='text-center'>
            <p className='font-bold'><Number value={807444} /></p>
            <span className='font-tiny'>
              <Text text='customer.resume.purchasesprom' />
            </span>
          </div>
        </Col>
        <Col span={8} className='box-border-left'>
          <div className='text-center'>
            <p className='font-bold'>0</p>
            <span className='font-tiny'>
              <Text text='customer.resume.purchasesquantity' />
            </span>
          </div>
        </Col>
        <Col span={8} className='box-border-left'>
          <div className='text-center'>
            <div>
              <Rate allowHalf defaultValue={2.5} style={{ fontSize: '0.8rem' }} />
            </div>
            <span className='font-tiny'>
              <Text text='customer.resume.rating' />
            </span>
          </div>
        </Col>
      </Row>
    )
  }
  _renderCustomerInfo = (data) => {
    return (
      <Row type='flex'>
        <Col span={8}>
          {this._renderPersonalInfo(data)}
        </Col>
        <Col span={16}>
          {this._renderOrdersResume(data)}
        </Col>
      </Row>
    )
  }

  _renderSectionWithTitle = (icon, title, content) => {
    return (
      <Row type='flex' className='box-title-container'>
        <Col span={24}>
          <div>
            <span><Icon type={icon} /></span>
            <p className='box-title'>
              <strong>{title}</strong>
            </p>
          </div>
        </Col>
        <Col span={24}>
          {content()}
        </Col>
      </Row>
    )
  }

  _renderAdressesList = () => {
    const adresses = [
      { label: 'Vicuña Mackenna 2004, 1707B, Santiago, REGIÓN METROPOLITANA', coordinates: [0, 1] },
      { label: 'Vicuña Mackenna 2004, 1707B, Santiago, REGIÓN METROPOLITANA', coordinates: [0, 1] },
      { label: 'Vicuña Mackenna 2004, 1707B, Santiago, REGIÓN METROPOLITANA', coordinates: [0, 1] }
    ]
    return (
      <Collapse bordered={false} defaultActiveKey={['0']} accordion>
        {adresses.map(({ label, coordinates }, key) => (
          <Panel header={label} key={key}>
            <GoogleMapsView showMarker />
          </Panel>
        ))}
      </Collapse>
    )
  }

  _renderLastPurchasesTable = () => {
    return (
      <LastPurchasesTable data={[]} />
    )
  }
  render () {
    const { data } = this.props
    return (
      <>
        <div className='box bordered' style={{ padding: 15, paddingBottom: 20 }}>
          {this._renderHeader()}
          {this._renderCustomerInfo(data)}
        </div>
        <div>
          {this._renderSectionWithTitle('shopping-cart', 'Ultimas Compras', this._renderLastPurchasesTable)}
          {this._renderSectionWithTitle('bar-chart', 'Direcciones', this._renderAdressesList)}
        </div>

      </>

    )
  }
}

CustomerResumeCard.propTypes = {
  data: PropTypes.array,
  toggleChildDrawer: PropTypes.func
}

export default CustomerResumeCard
